import { SettingsParser } from "./settings-parser";
import { CanvasSettings } from "../settings/canvas-settings";
import { getSizeSettings } from "../../utils/get-size-settings";

export class BaseCanvasParser extends SettingsParser {
  /*
  viewObjectParsers: new Map()
  */
  constructor(viewObjectParsers) {
    super();
    this.parsedFieldNames = ["x", "y", "width", "height", "items"];
    this.viewObjectParsers = viewObjectParsers;
  }

  static createSettings(settings, defaultSettings, viewObjectParsers) {
    if (settings === undefined) {
      return undefined;
    }
    let parsedSettings = {
      x: getSizeSettings(settings.x ?? defaultSettings?.x, 0, 0),
      y: getSizeSettings(settings.y ?? defaultSettings?.y, 0, 0),
      width: getSizeSettings(settings.width ?? defaultSettings?.width, 0, 1),
      height: getSizeSettings(settings.height ?? defaultSettings?.height, 0, 1)
    };
    if (settings.items !== undefined && viewObjectParsers !== undefined && viewObjectParsers.size > 0) {
      parsedSettings.items = [];
      let defaultViewObjects = new Map();
      if (defaultSettings?.items !== undefined) {
        for (let i = 0; i < defaultSettings.items.length; i++) {
          defaultViewObjects.set(defaultSettings.items[i].name, defaultSettings.items[i].settings);
        }
      }
      for (let itemIndex = 0; itemIndex < settings.items.length; itemIndex++) {
        let itemSettings = settings.items[itemIndex];
        let objParser = viewObjectParsers.get(itemSettings.type);
        if (objParser !== undefined) {
          itemSettings._defaultViewObjects = defaultViewObjects;
          let defaultObjSettings = defaultViewObjects.get(itemSettings.type);
          let viewObjectSettings = objParser.parse(itemSettings, defaultObjSettings);
          if (viewObjectSettings !== undefined) {
            parsedSettings.items.push(viewObjectSettings);
          }
        }
      }
    }
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = BaseCanvasParser.createSettings(settings, defaultSettings, this.viewObjectParsers);
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new CanvasSettings(parsedSettings);
  }
}
